import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import GuestLoginComponent from './guestLogin/guestLoginComponent';
import UnicefLoginComponent from './unicefLogin/unicefLoginComponent';

export default class LoginComponent extends React.Component<any, any> {
  state = {
    value: 0,
  };
  constructor(props: any) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeIndex = this.handleChangeIndex.bind(this);
    this.loginUser = this.loginUser.bind(this);
    this.clearData = this.clearData.bind(this);
  }

  clearData() {
    this.props.clearData()
  }

  loginUser(data: any) {
    console.log("Login component",data);
    this.props.loginUser(data)
  }

  handleChange = (event: any, value: any) => {
    this.setState({ value });
  };

  handleChangeIndex = (index: any) => {
    this.setState({ value: index });
  };

  isProductionUrl() {
    const currentUrl = window.location.href.toLowerCase();
    if (currentUrl.indexOf('localhost') !== -1 || currentUrl.indexOf('tst') !== -1 || currentUrl.indexOf('uat') !== -1) {
      return false;
    }
    else {
      return true;
    }
  }


  render() {
    return (
      <>

        <Typography component="h4" variant="title" align="center" gutterBottom={true} className="loginTitle">
          NutriDash 3.0
          </Typography>

        <Typography component="h4" variant="title" align="center" gutterBottom={true} className="loginSubTitle">
          {
            !this.isProductionUrl()
              ?
              <>
                Warning: This environment is for testing purpose only, do not enter realtime data. Go to <a href="https://www.unicefnutridash.org" target="blank">https://www.unicefnutridash.org</a> for actual data entry.
              </>
              : ''
          }
        </Typography>


        <AppBar position="static" color="default">
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            scrollButtons="off"
            variant="fullWidth"
            className="loginType"
          >
            <Tab label="UNICEF Login" className="unicef" />
            <Tab label="Guest Login" className="guest" />
          </Tabs>
        </AppBar>

        {
          this.state.value === 0 && <Typography component="div" style={{ padding: 8 * 3 }}>
            <UnicefLoginComponent />
          </Typography>
        }

        {
          this.state.value === 1 && <Typography component="div" style={{ padding: 8 * 3 }}>
            <GuestLoginComponent
              loggedInUser={this.props.loggedInUser}
              loginUser={this.loginUser}
              handleComponentRendering={this.props.handleComponentRendering}
              clearData={this.clearData}
              appSettings={this.props.appSettings}
              verifyCaptcha={this.props.verifyCaptcha}
              isCaptchaVerified={this.props.isCaptchaVerified}
            />
          </Typography>
        }

      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/login/loginComponent.tsx